<template>
  <div class="page">
    <div class="page-title">新增推廣碼</div>
    <div class="page-box">
      <promoteFrom :form="form" ref="form"></promoteFrom>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {addPromotionCodes} from '@/api/order'
import promoteFrom from "./components/promoteFrom.vue";
export default {
  components: { promoteFrom },
  data() {
    return {
      form: {
        code: null,
        description: null,
        discount: null,
      },
    };
  },
  methods: {
    onSubmit() {
      // 表单校验
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.addPromotionCodes();
          }
       });
    },
    addPromotionCodes() {
      addPromotionCodes(this.form).then(() => {
        this.$message({
          message: "新增成功",
          type: "success",
        })
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-button {
  margin-top: 20px;
}
.page-box {
  background-color: #fff;
  padding: 20px;
    margin: 20px 0;
}
</style>